import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthSignalService } from '../state/auth.signal';

export const zohoGuard: CanActivateFn = (route, state) => {
    const authService = inject(AuthSignalService);
    const router = inject(Router);

    const user = authService.user();
    if (user && !user.zohoLinked) {
        // Redirigir a la pantalla de vinculación de Zoho
        return router.createUrlTree(['/link-zoho']);
    }

    return true;
};
